import React from 'react'
import { useSelector } from 'react-redux';

const NoResult = () => {
  const lang = useSelector((state) => state.culture.language);

  return (
    <section className="ContentArea">
      <div className="  minHeight">
        <div className=" ">
          <div className="no_result d-flex flex-column justify-content-center align-items-center mt-2">
            <i className="no_result_package"></i>
            <h4>{lang.no_result_found}</h4>
            <p>
              NO PACKAGE FOUND FOR YOUR CURRENT SEARCH
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default NoResult